import type { TFunction } from "i18next";

// Junta a pergunta digitada com o texto lido do print. Na conversa aparece só a pergunta
// (com o selo "print anexado"); para a SAK vai a pergunta + o texto do print, que é o que
// permite a ela achar o artigo certo para aquele erro.
export const montarPerguntaComPrint = (
  texto: string,
  textoImagem: string | undefined,
  t: TFunction
) => {
  const exibicao = texto.trim() || (textoImagem !== undefined ? t("duvida_do_print") : "");
  const api = textoImagem ? `${exibicao}\n\n${t("api_texto_print")}:\n${textoImagem}` : exibicao;
  return { exibicao, api, extras: textoImagem !== undefined ? { anexoTexto: textoImagem } : undefined };
};
